import { render } from "./AddAddressModel.vue?vue&type=template&id=12d547ef&scoped=true"
import script from "./AddAddressModel.vue?vue&type=script&lang=js"
export * from "./AddAddressModel.vue?vue&type=script&lang=js"

import "./AddAddressModel.vue?vue&type=style&index=0&id=12d547ef&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d547ef"]])

export default __exports__